"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGift(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M17.642 0c1.74 0 3.275 1.056 3.275 3.337 0 1.085-.53 2.01-1.406 2.792l3.212-.001c.705 0 1.276.572 1.276 1.277v4.085c0 .617-.438 1.132-1.02 1.25v9.473c0 .987-.8 1.787-1.788 1.787H2.808c-.987 0-1.787-.8-1.787-1.787V12.74A1.277 1.277 0 010 11.49V7.405C0 6.7.572 6.128 1.277 6.128l3.193.001c-.876-.78-1.406-1.707-1.406-2.792C3.064 1.056 4.599 0 6.338 0c2.2 0 3.974 1.381 5.652 4.85C13.668 1.381 15.443 0 17.642 0zm-6.409 12.766h-8.68v9.447c0 .12.084.222.197.248l.058.007h8.425v-9.702zm10.213 0h-8.681v9.702h8.426c.12 0 .222-.084.249-.197l.006-.058v-9.447zm1.022-5.106H1.532v3.574h20.936V7.66zm-4.826-6.128c-1.641 0-3.031 1.162-4.559 4.596h3.552a.767.767 0 01.176-.098l.12-.051a6.506 6.506 0 001.228-.723c.784-.59 1.226-1.24 1.226-1.919 0-1.287-.754-1.805-1.743-1.805zm-11.304 0c-.989 0-1.742.518-1.742 1.805 0 .679.441 1.33 1.224 1.919.297.223.619.419.94.584l.289.139c.05.023.09.04.12.051a.767.767 0 01.177.098h3.55C9.37 2.694 7.98 1.532 6.338 1.532z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgGift;
exports.default = _default;